/** Região de mercado do build — REACT_APP_MARKET_REGION=BR | PT (padrão BR). */
export type MarketRegion = 'BR' | 'PT';

const RAW = String(process.env.REACT_APP_MARKET_REGION || 'BR').trim().toUpperCase();

export const marketRegion: MarketRegion = RAW === 'PT' ? 'PT' : 'BR';

export function isPortugalMarket(): boolean {
  return marketRegion === 'PT';
}

export function isBrazilMarket(): boolean {
  return marketRegion === 'BR';
}

export type MarketAppConfig = {
  market_region: MarketRegion;
  tax_id_label: string;
  tax_id_guardian_label: string;
  phone_country_code: string;
  phone_example_e164_digits: string;
};

export function buildMarketAppConfigFromEnv(): MarketAppConfig {
  const pt = isPortugalMarket();
  return {
    market_region: marketRegion,
    tax_id_label: pt ? 'NIF' : 'CPF',
    tax_id_guardian_label: pt ? 'NIF do responsável' : 'CPF do Responsável',
    phone_country_code: pt ? '351' : '55',
    phone_example_e164_digits: pt ? '351912345678' : '5511999999999',
  };
}

/** Preferir resposta do backend (/auth/me ou /auth/app-config) quando disponível. */
let runtimeConfig: MarketAppConfig | null = null;

export function setRuntimeMarketAppConfig(cfg: MarketAppConfig | null | undefined) {
  runtimeConfig = cfg && cfg.market_region ? cfg : null;
}

export function getMarketAppConfig(): MarketAppConfig {
  return runtimeConfig ?? buildMarketAppConfigFromEnv();
}
